import { matchPath } from 'react-router-dom';

import { ROUTE_CODES } from 'js/config/routes';

export function isRenderer() {
  const pathname = window.location.pathname.replace(import.meta.env.VITE_ASSET_PATH, '/');
  const match = matchPath(pathname, ROUTE_CODES.RENDER);
  return match !== null;
}
